<template>
    <div class="mesin-edc-content">
        <SOSlotBase :container-name="'buat-settlement-content'">
            <template v-slot:title-bar v-if="!isOpenCamera">
                <div>
                    <SOTitleBar :page-title="`Buat Settlement`" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="f-c-black f-regular f-14">
                    <div class="p-x-20 p-t-16" v-if="!isOpenCamera">
                        <p class="m-d-0">
                            {{ detailMesin.nama_mesin_edc }}
                            <span class="f-c-midgrey"> • {{ detailMesin.nama_outlet }}</span>
                        </p>
                        <p class="m-d-0 f-c-midgrey">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="m-d-8"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.16683 0.833334C1.62707 0.833334 2.00016 1.20643 2.00016 1.66667V6.77083C2.00016 7.32337 2.21966 7.85327 2.61036 8.24397C3.00106 8.63467 3.53096 8.85417 4.0835 8.85417H10.8217L8.59841 6.63092C8.27297 6.30549 8.27297 5.77785 8.59841 5.45241C8.92384 5.12697 9.45148 5.12697 9.77692 5.45241L13.4228 9.09824C13.7482 9.42368 13.7482 9.95132 13.4228 10.2768L9.77692 13.9226C9.45148 14.248 8.92384 14.248 8.59841 13.9226C8.27297 13.5972 8.27297 13.0695 8.59841 12.7441L10.8217 10.5208H4.0835C3.08893 10.5208 2.13511 10.1257 1.43185 9.42248C0.728584 8.71922 0.333496 7.7654 0.333496 6.77083V1.66667C0.333496 1.20643 0.706592 0.833334 1.16683 0.833334Z"
                                    fill="#6F7287"
                                />
                            </svg>
                            <span class="m-l-8">
                                {{ detailMesin.rekening_owner.nama }} - {{ detailMesin.rekening_owner.nomor_rekening }}
                            </span>
                        </p>
                    </div>
                    <div class="separator-line m-t-16 m-d-16" v-if="!isOpenCamera" />
                    <div class="p-x-20" :class="{ fullScreen: isOpenCamera1, dNone: isOpenCamera2 }">
                        <SOUploadNota
                            ref="uploadBuktiSettlement"
                            id="camera-1"
                            label="Bukti Settlement"
                            :images="uploadBuktiSettlement"
                            :camera-open="camera1.open"
                            :full-size="camera1.fullSize"
                            :preview-img="selectedPreview"
                            :is-required="true"
                            @setCamera="onToggleOpen($event, 'camera1')"
                            @setFullSize="onToggleFullSize($event, 'camera1')"
                            @setImages="setImages($event, 'uploadBuktiSettlement')"
                            @deleteImg="onDeleteImg($event, 'uploadBuktiSettlement')"
                            @preview="onSelected($event)"
                            @hook:mounted="reloadImage"
                        />
                        <label class="footer-note" v-if="!isOpenCamera">
                            Cetak settlement di mesin EDC, lalu foto sebagai bukti.
                        </label>
                        <ErrorMessage
                            class="error"
                            label="Bukti Settlement"
                            :validation="$v.posted.bukti_settlement_files"
                        />
                    </div>
                    <div class="p-x-20 m-t-16" v-if="!isOpenCamera" @click="setDateToday('waktu_settlement')">
                        <SOInputDateTime
                            ref="tglSettlement"
                            title="Settlement pada"
                            id="tgl-settlement"
                            placeholder="12 Jan 2021, 21:00"
                            :value="posted.waktu_settlement"
                            :max-date="`${$moment().format('YYYY-MM-DD')}T${$moment().format('HH:mm')}`"
                            @get-date="changeDate($event, 'waktu_settlement')"
                            :required="true"
                        />
                        <label class="footer-note">Sesuaikan dengan struk settlement dari mesin.</label>
                        <ErrorMessage class="error" label="Settlement pada" :validation="$v.posted.waktu_settlement" />
                    </div>

                    <div class="separator-line m-t-16 m-d-16" v-if="!isOpenCamera" />
                    <div class="p-x-20" v-if="!isOpenCamera">
                        <div class="d-grid-12 f-16 f-c-black f-regular nominal-settlement m-d-16">
                            <div class="grid-cspan-6">
                                <p class="m-d-0 f-12 f-c-midgrey">Settlement</p>
                                <p class="m-d-0">{{ totalPembayaran | currency }}</p>
                            </div>
                            <div class="grid-cspan-6">
                                <p class="m-d-0 f-12 f-c-midgrey">Biaya MDR</p>
                                <p class="m-d-0">{{ biayaMdr | currency }}</p>
                            </div>
                        </div>
                        <div class="m-d-16">
                            <SOInputNominal
                                ref="nominal_diterima"
                                :prefix-left="true"
                                :placeholder="'1234'"
                                :id="`nominal_diterima`"
                                title="Nominal yang diterima"
                                :use-autocomplete="false"
                                :prefix="`Rp`"
                                :required="true"
                                :default-value="nominal.formatted"
                                v-model="nominal"
                                :max-value="totalPembayaran.toString()"
                            />
                            <label class="footer-note">Nominal uang yg masuk di rekening bank.</label>
                            <ErrorMessage
                                class="error"
                                label="Nominal yang diterima"
                                :validation="$v.posted.nominal_diterima"
                            />
                        </div>
                        <div class="m-d-16" @click="setDateToday('waktu_diterima')">
                            <SOInputDateTime
                                title="Diterima pada"
                                id="tgl-diterima"
                                placeholder="12 Jan 2021, 21:00"
                                :value="posted.waktu_diterima"
                                :min-date="posted.waktu_settlement"
                                @get-date="changeDate($event, 'waktu_diterima')"
                                :required="true"
                            />
                            <label class="footer-note">Waktu uang yg masuk di rekening bank.</label>
                            <ErrorMessage class="error" label="Diterima pada" :validation="$v.posted.waktu_diterima" />
                        </div>
                    </div>
                    <div class="separator-line m-t-16 m-d-16" v-if="!isOpenCamera" />
                    <div class="p-x-20">
                        <SOButtonExpand
                            ref="biayaTambahan"
                            text="Data opsional"
                            id="opt-settlement"
                            :full-height="220"
                            @hook:mounted="onMountedBiaya"
                        >
                            <template v-slot:content>
                                <div>
                                    <div
                                        id="camera-2-content"
                                        :class="{
                                            fullScreen: isOpenCamera2,
                                            dNone: isOpenCamera1,
                                            cam2: isOpenCamera2,
                                            mT35: camera2.fullSize,
                                        }"
                                    >
                                        <SOUploadNota
                                            ref="uploadMutasiRekening"
                                            label="Bukti mutasi rekening"
                                            id="camera-2"
                                            :images="uploadMutasiRekening"
                                            :camera-open="camera2.open"
                                            :full-size="camera2.fullSize"
                                            :preview-img="selectedPreview"
                                            @setCamera="onToggleOpen($event, 'camera2')"
                                            @setFullSize="onToggleFullSize($event, 'camera2')"
                                            @setImages="setImages($event, 'uploadMutasiRekening')"
                                            @deleteImg="onDeleteImg($event, 'uploadMutasiRekening')"
                                            @preview="onSelected($event)"
                                            @hook:mounted="reloadImage"
                                        />
                                        <label class="footer-note">Sebagai bukti settlement telah sesuai.</label>
                                    </div>
                                    <div class="m-t-16">
                                        <SOInputRegular
                                            :title="'Catatan'"
                                            :placeholder="'Keterangan...'"
                                            v-model="posted.keterangan"
                                        />
                                    </div>
                                </div>
                            </template>
                        </SOButtonExpand>
                    </div>
                    <div class="separator-line"></div>
                    <div class="p-x-20 p-t-24" v-if="!isOpenCamera">
                        <SOButton
                            :primary="true"
                            :text="'Buat Settlement'"
                            :full="true"
                            :id="`btn-create-settlement`"
                            :loading="isFetching"
                            :disable="isFetching"
                            @action="doSave"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import SOButton from "@/so-components/global/ui/SOButton";
import SOButtonExpand from "@/so-components/global/ui/SOButtonExpand";
import SOUploadNota from "@/so-components/global/ui/SOUploadNota.vue";
import SOInputDateTime from "@/so-components/global/input/SOInputDateTime.vue";
import SOInputNominal from "@/so-components/global/input/SOInputNominal.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import ErrorMessage from "@/component-items/ErrorMessage";

import { required } from "vuelidate/lib/validators";
import { moduleName } from "../store/state";

export default {
    name: "BuatSettlement",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        SOButtonExpand,
        SOUploadNota,
        SOInputDateTime,
        SOInputNominal,
        SOInputRegular,
        ErrorMessage,
    },
    mounted() {
        this.smartTrackingView("add_settlement_mesin_edc_step_2");

    },
    data() {
        return {
            camera1: {
                open: false,
                fullSize: false,
            },
            camera2: {
                open: false,
                fullSize: false,
            },
            isExpandBiaya: false,
            selectedPreview: null,
            lockViewId: null,
            uploadBuktiSettlement: [],
            uploadMutasiRekening: [],
            nominal: {
                raw: null,
                formatted: "0",
            },
            posted: {
                idedc: this.$route.params.id_mesin,
                waktu_settlement: "",
                biaya_mdr: 0,
                nominal_diterima: "",
                waktu_diterima: "",
                keterangan: "",
                data_pembayaran_json: {},
                bukti_settlement_files: [],
                bukti_mutasi_files: [],
            },
        };
    },
    updated() {
        if (this.lockViewId) {
            document.getElementById(this.lockViewId).scrollIntoView();
        }
    },
    validations: {
        posted: {
            waktu_settlement: {
                required,
            },
            bukti_settlement_files: {
                required,
            },
            nominal_diterima: {
                required,
            },
            waktu_diterima: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            selectedPembayaran: "selectedPembayaran",
            detailMesin: "detailMesin",
            isFetching: "isFetching",
        }),
        isOpenCamera() {
            return this.isOpenCamera1 || this.isOpenCamera2;
        },
        isOpenCamera1() {
            return this.camera1.open || this.camera1.fullSize;
        },
        isOpenCamera2() {
            return this.camera2.open || this.camera2.fullSize;
        },
        totalPembayaran() {
            let total = 0;
            this.selectedPembayaran.forEach((data) => {
                data.items.forEach((item) => {
                    total += item.nominal;
                });
            });

            return total;
        },
        dataPembayaran() {
            let dataPembayaran = [];
            this.selectedPembayaran.forEach((data) => {
                data.items.forEach((item) => {
                    dataPembayaran.push({ idpembayaran: item.idbayar });
                });
            });

            return dataPembayaran;
        },
        biayaMdr() {
            return this.nominal.raw ? this.totalPembayaran - this.nominal.raw : 0;
        },
    },
    methods: {
        ...mapActions({
            saveSettlement: `${moduleName}/saveSettlement`,
            setFetching: `${moduleName}/setFetching`,
        }),
        back() {
            this.$router.push({ name: "mesin.edc.pilih.pembayaran", query: { backto: this.$route.query.backto } });
        },
        onMountedBiaya() {
            this.$refs.biayaTambahan.setExpand(this.isExpandBiaya);
        },
        onToggleOpen(val, cam) {
            this[cam].open = val;
            if (val) {
                this.lockViewId = "";
            }
            if (cam === "camera2") {
                this.isExpandBiaya = true;
                if (!val) {
                    this.lockViewId = "camera-2-content";
                }
            }
        },
        onToggleFullSize(val, cam) {
            this[cam].fullSize = val;
            if (val) {
                this.lockViewId = "";
            }
            if (cam === "camera2") {
                this.isExpandBiaya = true;
                if (!val) {
                    this.lockViewId = "camera-2-content";
                }
            }
        },
        reloadImage() {
            this.$refs.uploadMutasiRekening.handleImages();
            this.$refs.uploadBuktiSettlement.handleImages();
        },
        onSelected(idx) {
            this.selectedPreview = idx;
        },
        setImages(data, target) {
            this[target] = data;
        },
        onDeleteImg(idx, target) {
            this[target].splice(idx, 1);
        },
        setDateToday(target) {
            if (!this.posted[target]) {
                this.posted[target] = `${this.$moment().format("YYYY-MM-DD")}T${this.$moment().format("HH:mm")}`;
            }
        },
        changeDate(date, target) {
            this.posted[target] = date;
        },
        setPosted() {
            this.posted.biaya_mdr = this.biayaMdr;
            this.posted.nominal_diterima = this.nominal.raw;
            this.posted.data_pembayaran_json = JSON.stringify(this.dataPembayaran);
            this.posted.bukti_settlement_files = this.uploadBuktiSettlement;
            this.posted.bukti_mutasi_files = this.uploadMutasiRekening;
        },
        errorValidation() {
            let { waktu_settlement, bukti_settlement_files, nominal_diterima, waktu_diterima } = this.$v.posted;
            waktu_settlement.$touch();
            bukti_settlement_files.$touch();
            nominal_diterima.$touch();
            waktu_diterima.$touch();

            return (
                waktu_settlement.$invalid ||
                bukti_settlement_files.$invalid ||
                nominal_diterima.$invalid ||
                waktu_diterima.$invalid
            );
        },
        async doSave() {
            await this.setPosted();
            if (this.errorValidation()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            this.smartTrackingClick("simpan_settlement_mesin_edc");
            await this.saveSettlement(this.posted)
                .then((response) => {
                    if (!response.data) {
                        this.$toast.error(response);
                    }else{
                        let { code, data, status, msg } = response.data;
                        if (code === 200) {
                            if (status) {
                                this.$router.push({
                                    name: "mesin.edc.detail",
                                    params: { id_mesin: this.$route.params.id_mesin },
                                });
                                this.$toast.success(msg);
                            } else {
                                this.$toast.error(msg);
                            }
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });


        },
    },
};
</script>
<style scoped>
.fullScreen {
    padding-left: 0px;
    padding-right: 0px;
    margin-top: -52px;
}
.dNone {
    display: none;
}
.nominal-settlement {
    border: 1px solid #c8d0dd;
    padding: 8px 16px;
    border-radius: 4px;
}
.cam2 {
    margin-top: -120px;
    margin-left: -20px;
    position: absolute;
    width: 100vw;
    z-index: 200;
}
.mT35 {
    margin-top: -135px;
}
</style>
